import axios, { type AxiosInstance } from "axios";
import axiosRetry from "axios-retry";

// The one configured axios instance. Imported only by api/ resource modules,
// never by components directly, so request URLs live solely in api/.
const client: AxiosInstance = axios.create();

client.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axiosRetry(client, { retries: 3 });

export default client;
